<template>
  <div id="brandingCategories">

    <div class="page-title" >
      <span class="name">{{$t('branding.categories')}}</span>
      <button class="save btn btn-primary" @click="save" v-if="$store.getters.loggedUserCanSaveInventory">{{$t("save")}}</button>
    </div>

    <div class="branding unassigned">
      <div class="branding-name">
        <svgicon v-if="unassignedCategories.length > 0" src="icon/danger.svg" :height="16" :width="16"></svgicon>
        {{$t('branding.unassigned')}}
      </div>
      <Draggable class="branding-categories" v-model="unassignedCategories" group="category" @start="drag=true" @end="drag=false">
        <div class="category" v-for="(category, categoryIndex) of unassignedCategories" :key="'unassigned-' + categoryIndex">
          {{$to(category.name)}}
          <svgicon src="icon/hamburger.svg" :height="14" :width="14"></svgicon>
        </div>
      </Draggable>
      <div class="all-assigned" v-if="unassignedCategories.length === 0">
        <svgicon src="icon/smile.svg" :height="50" :width="50"></svgicon>
        <div class="assigned-title">{{$t('branding.assigned_title')}}</div>
        <div class="assigned-description">{{$t('branding.assigned_description')}}</div>
      </div>
    </div>

    <div class="hashed"></div>

    <div class="brandings">
      <div class="branding" v-for="(branding, brandingIndex) of brandings" :key="'branding-' + brandingIndex">
        <div class="branding-name">
          <img class="logo" v-if="branding.logo" :src="Parameters.urlFileServer + branding.logo.url">
          {{$to(branding.name)}}
        </div>
        <Draggable class="branding-categories"
                   v-model="branding.categories" group="category" @start="drag=true" @end="drag=false">
          <div class="category" v-for="(category, categoryIndex) of branding.categories" :key="'branding-' + brandingIndex + categoryIndex">
            {{$to(category.name)}}
            <svgicon src="icon/hamburger.svg" :height="14" :width="14"></svgicon>
          </div>
        </Draggable>
        <div class="empty" v-if="branding.categories.length === 0">
          {{$t('branding.empty_category')}}
        </div>
      </div>
    </div>

    <br>
    <div class="footer-actions">
      <button class="btn btn-secondary" @click="back">{{$t('back')}}</button>
    </div>

  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import Draggable from 'vuedraggable';

  export default {
    name: "brandingCategories",

    components: { Draggable },

    data() {
      return {
        inventory: null,
        brandings: [],
        categories: [],
        unassignedCategories: [],
        Parameters
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "branding.title";
      this.$store.state.pageIcon = "/icon/menu.svg";

      showSpinner();
      this.inventory = await this.$store.getters.getContextInventory;
      await this.loadBrandings();
      await this.loadCategories();
      this.loadUnassignedCategories();
      hideSpinner();
    },

    methods: {
      ...mapActions(["getBrandings", "getCategories", "saveBranding"]),

      back() {
        this.$router.push(this.$router.buildContext("/brandings"));
      },

      async loadBrandings() {
        let response = await this.getBrandings({inventoryId: this.inventory.id})
        if (response) {
          this.brandings = response;
        }
      },

      async loadCategories() {
        let response = await this.getCategories({inventoryId: this.inventory.id})
        if (response) {
          this.categories = response;
        }
        //Categories object mapping to branding
        for (let branding of this.brandings) {
          for (let i = branding.categories.length; i >= 0; i--) {
            let foundCategory = this.categories.find(c => c.id === branding.categories[i]);
            if (foundCategory) {
              branding.categories[i] = foundCategory; //remap category
            } else {
              branding.categories.splice(i, 1); //delete from list if category is not found
            }
          }
        }
      },

      loadUnassignedCategories() {
        this.unassignedCategories = this.categories.filter(c => !c.branding || !this.brandings.find(b => b.categories.find(d => d.id === c.id)));
      },

      async save() {
        let calls = [];
        for (let branding of this.brandings) {
          let data = {
            categories: branding.categories.map(c => c.id)
          };
          calls.push(this.saveBranding({inventoryId: this.inventory.id, brandingId: branding.id, data: data}));
        }
        showSpinner();
        let response = await Promise.all(calls);
        hideSpinner();
        if (response) {
          toast(this.$t('inventory.success'), "success", this.$t('success'));
        } else {
          toast(this.$t("error.no_server"), "error");
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .brandings {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 1200px;
    margin-left: auto;
    margin-right: auto;
  }
  .all-assigned {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: center;
    text-align: center;
    align-items: center;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 20%;

    .svgicon {
      fill: #fab8af;
    }
    .assigned-title {
      color: #aaa;
      font-weight: 500;
      margin-bottom: 5px;
      margin-top: 15px;
    }
    .assigned-description {
      color: #aaa;
      font-size: 14px;
      margin-bottom: 15px;
    }
  }
  .hashed {
    width: 100%;
    border-bottom: 2px dashed #d9d9d9;
    padding-top: 15px;
    margin-bottom: 15px;
  }
  .logo {
    height: 18px;
    width: auto;
    margin-right: 14px;
  }
  .branding {
    border: 1px solid #f2f2f2;
    background-color: white;
    border-radius: 6px;
    padding: 15px;
    width: 280px;
    margin: 10px 5px;
    display: flex;
    flex-direction: column;
    position: relative;

    &.unassigned {
      width: 100%;
      max-width: 1200px;
      margin-left: auto;
      margin-right: auto;

      .branding-name {
        .svgicon {
          margin-right: 10px;
          fill: #fa8c7d;
        }
      }

      .branding-categories {
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        align-items: flex-start;
        align-content: flex-start;

        .category {
          width: 32%;
          margin: 4px 7px;
        }
      }
    }
  }
  .branding-categories {
    flex-grow: 1;
    min-height: 200px;
    display: flex;
    flex-direction: column;
  }
  .empty {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #aaa;
    font-size: 14px;
    pointer-events: none;
    padding: 0 30px;
    font-style: italic;
    position: absolute;
    bottom: 30%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
  }
  .branding-name {
    font-weight: 500;
    padding-bottom: 15px;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }
  .category {
    padding: 10px;
    font-size: 14px;
    color: white;
    background-color: #fc6650;
    fill: rgba(255, 255, 255, 0.4);
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:not(:last-child) {
      margin-bottom: 5px;
    }
  }
</style>

